import { makeAutoObservable } from "mobx";
import {
    getAllRoles
} from 'app/services/RoleService';
import { toast } from "react-toastify";

export default class HealthCareRoomStore {
    listAllRoles = [];

    constructor() {
        makeAutoObservable(this);
    }

    getAllRoles = async () => {
        return await getAllRoles()
            .then(({ data }) => {
                this.listAllRoles = data || [];
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu quyền người dùng có lỗi");
            })
    }

    //for choosing healthcare room popup in ChooseRolePopup.jsx 
    listRoom = [];
    roomIdSet = null;

    isValidRoom = room => {
        if (room && room?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addRoom = room => {
        if (!this.isValidRoom(room)) return;
        this.listRoom.push(room);
        this.roomIdSet.add(room?.id);
    }

    initializeListRoom = rooms => {
        this.roomIdSet = new Set();
        this.listRoom = [];
        if (rooms && rooms?.length > 0) {
            for (let i = 0; i < rooms.length; i++) {
                this.addRoom(rooms[i]);
            }
        }
    }

    removeRoom = room => {
        if (!this.isValidRoom(room)) return;
        if (this.roomIdSet.has(room?.id)) {
            this.roomIdSet.delete(room?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = room => {
        if (!this.isValidRoom(room)) return;
        return this.roomIdSet.has(room?.id);
    }

    getRoomIdSet = () => {
        return this.roomIdSet;
    }

    getListRoom = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listRoom && this.listRoom?.length > 0) {
            for (let i = 0; i < this.listRoom.length; i++) {
                const room = this.listRoom[i];
                if (this.isExist(room) && !bufferIdSet.has(room?.id)) {
                    data.push(room);
                    bufferIdSet.add(room?.id);
                }
            }
        }
        this.listRoom = data;
        return data;
    }
    //end
    // listRole = [];
    // roleIdSet = null;

    // isValidRole = room => {
    //     if (room && room?.id) return true;
    //     console.error("Invalid manipulated element");
    //     return false;
    // }

    // addRole = room => {
    //     if (!this.isValidRole(room)) return;
    //     this.listRole.push(room);
    //     this.roleIdSet.add(room?.id);
    // }

    // initializeListRole = roles => {
    //     this.roleIdSet = new Set();
    //     this.listRole = [];
    //     if (roles && roles?.length > 0) {
    //         for (let i = 0; i < roles.length; i++) {
    //             this.addRole(roles[i]);
    //         }
    //     }
    // }

    // removeRoom = role => {
    //     if (!this.isValidRole(role)) return;
    //     if (this.roleIdSet.has(role?.id)) {
    //         this.roleIdSet.delete(role?.id);
    //     }
    //     else {
    //         console.error("Element is not exist");
    //     }
    // }

    // isExist = role => {
    //     if (!this.isValidRole(role)) return;
    //     return this.roleIdSet.has(role?.id);
    // }

    // getRoleIdSet = () => {
    //     return this.roleIdSet;
    // }

    // getListRole = () => {
    //     const bufferIdSet = new Set();
    //     const data = [];
    //     if (this.listRole && this.listRole?.length > 0) {
    //         for (let i = 0; i < this.listRole.length; i++) {
    //             const room = this.listRole[i];
    //             if (this.isExist(room) && !bufferIdSet.has(room?.id)) {
    //                 data.push(room);
    //                 bufferIdSet.add(room?.id);
    //             }
    //         }
    //     }
    //     this.listRole = data;
    //     return data;
    // }
    //end
}